import { render, staticRenderFns } from "./CargadorDepartamentos.vue?vue&type=template&id=4fece018&scoped=true&"
import script from "./CargadorDepartamentos.vue?vue&type=script&lang=js&"
export * from "./CargadorDepartamentos.vue?vue&type=script&lang=js&"
import style0 from "./CargadorDepartamentos.vue?vue&type=style&index=0&id=4fece018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fece018",
  null
  
)

export default component.exports